"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = numberFormatter;

var _formatter = _interopRequireDefault(require("../../../utils/formatter"));

var _parse = _interopRequireDefault(require("./parse"));

var formatLength3 = '{{ddd}}';
var formatLength4 = '{{d}} {{ddd}}';
var formatLength5 = '{{dd}} {{ddd}}';
var formatLength6 = '{{ddd}} {{ddd}}';
var longFormat = '{{d}} {{ddd}} {{ddd}} {{ddd}} {{ddd}} {{ddd}} {{ddd}} {{ddd}} {{ddd}} {{ddd}} {{ddd}} {{ddd}} {{ddd}} {{ddd}} {{ddd}} {{ddd}} {{ddd}}';

function numberFormatter(value, separators, fractionLength) {
  value = (0, _parse["default"])(value, separators); // format only valid number
  // input can be on start point and contains only dot or sign

  if (value && !['.', '-'].includes(value)) {
    var _int = Math.trunc(value),
        sign = Math.sign(_int) < 0 ? '-' : '';

    var decimal = value.match(/\.[0-9]{0,10}/) || '';

    if (decimal) {
      decimal = decimal[0].substr(0, fractionLength + 1);
    }

    var abs = Math.abs(_int);
    var format = longFormat;

    if (abs <= 999) {
      format = formatLength3;
    } else if (abs <= 9999) {
      format = formatLength4;
    } else if (abs <= 99999) {
      format = formatLength5;
    } else if (abs <= 999999) {
      format = formatLength6;
    }

    return "".concat(sign).concat((0, _formatter["default"])(Math.abs(_int), format)).concat(decimal);
  } else {
    return value;
  }
}